import { useEffect, useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ChatbotWidget } from "../components/ChatbotWidget";
import { useToggle } from "../contexts/ToggleContext";
import { api } from "../lib/api";

export default function PolicyPage() {
    const { slug } = useParams();
    const enabled = useToggle("footer_policies");
    const [page, setPage] = useState(null);
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setLoading(true);
        setNotFound(false);
        Promise.all([
            api.get(`/policy-pages/${slug}`).catch(() => null),
            api.get("/policy-pages").catch(() => ({ data: [] })),
        ]).then(([pageRes, listRes]) => {
            if (!pageRes) {
                setNotFound(true);
                setPage(null);
            } else {
                setPage(pageRes.data);
            }
            setPages(listRes.data || []);
        }).finally(() => setLoading(false));
    }, [slug]);

    if (!enabled) return <Navigate to="/" replace />;

    return (
        <div className="min-h-screen bg-ivory" data-testid="policy-page">
            <Header />
            <main className="max-w-[1100px] mx-auto px-6 lg:px-12 py-12">
                {loading ? (
                    <div className="text-inkMuted">Loading…</div>
                ) : notFound || !page ? (
                    <div>
                        <span className="label-eyebrow">Policies</span>
                        <h1 className="mt-3 font-display text-4xl text-inkDark">Page not found</h1>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                        <aside className="lg:col-span-3" data-testid="policy-sidebar">
                            <span className="label-eyebrow">Policies</span>
                            <nav className="mt-3 space-y-1.5">
                                {pages.map((p) => (
                                    <Link
                                        key={p.slug}
                                        to={`/policy/${p.slug}`}
                                        className={`block rounded-xl px-3 py-2 text-sm transition-colors ${p.slug === slug ? "bg-skyblue/40 text-inkDark" : "text-inkDark/80 hover:bg-beige"}`}
                                        data-testid={`policy-nav-${p.slug}`}
                                    >
                                        {p.title}
                                    </Link>
                                ))}
                            </nav>
                        </aside>
                        <article className="lg:col-span-9 bg-ivory rounded-2xl border border-inkDark/5 p-6 lg:p-10" data-testid="policy-body">
                            <span className="label-eyebrow">Sukaanyas atelier</span>
                            <h1 className="mt-2 font-display text-4xl sm:text-5xl text-inkDark tracking-tight">{page.title}</h1>
                            <div className="prose-policy mt-8 text-inkDark/90 leading-relaxed">
                                <ReactMarkdown>{page.bodyMarkdown || ""}</ReactMarkdown>
                            </div>
                        </article>
                    </div>
                )}
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
